/**
 * "Our top selling servers" — mirrors the section of the same name on
 * quantarock.in so the two sites quote one set of figures. If a price changes
 * there, change it here too; these are the only published prices on the shop.
 *
 * Source of truth: quantarock.in top-selling-servers section.
 * `productSlug` links a card to its catalogue page where the exact model
 * exists. Leave it null otherwise — the card then asks for the configuration
 * directly rather than sending a buyer to a different server.
 */

export const DEALS_LAST_REVIEWED = "August 2026";

export const DEALS_EYEBROW = "Refurbished enterprise server";
export const DEALS_CURRENCY_NOTE = "OTC /- INR + GST";

export const DEALS = [
  {
    id: "dell-r630",
    model: "Dell R630",
    price: 20000,
    // No R630 in the catalogue — R620, R720 and R730 are the closest models.
    productSlug: null,
    highlights: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "Dell Perc H730 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
  {
    id: "dell-r730xd",
    model: "R730XD",
    price: 29999,
    // The catalogue carries the R730, which is a different chassis.
    productSlug: null,
    highlights: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "Dell Perc H730 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
  {
    id: "hpe-dl360-gen9",
    model: "DL360 Gen 9 4LFF",
    price: 19999,
    productSlug: "servers/hpe-proliant-dl360-gen9",
    highlights: [
      "Up to 1 Year Warranty",
      "100% Tested and Verified",
      "HPE P440/P441 Raid Controller",
      "Free consultation",
      "Configuration support",
    ],
  },
];
